/**
 * La ruta a la ficha de una facility, a partir de su número de fideicomiso.
 *
 * Vive acá y no en cada componente porque el mismo Overview le ofrece al
 * usuario **dos caminos al mismo lugar** —la tarjeta del carrusel y el
 * renglón de la tabla— y abrir rutas distintas según desde dónde se haga clic
 * es la clase de incoherencia que nadie reporta y todos sufren (MR !1365 S5).
 *
 * Dos cosas que la ruta tiene que resolver:
 *
 * - **La barra no sobrevive en un segmento de URL**, así que `F/1554` viaja
 *   como `F-1554`. Es lo que el guard y `OperationsState` esperan.
 * - **Un número agrupado** —`"F/1477 / F/1477C"`— es un solo renglón pero
 *   varios fideicomisos. Se abre el **primero**, que es el que el guard sabe
 *   resolver; mandar la cadena entera produce una ruta que no existe.
 *
 * El separador se parte por ` / ` con espacios, que es como lo arma el
 * backend, y después se recorta: así un espaciado distinto no cambia el
 * resultado.
 */
export function facilityRoute(trustNumber: string | null | undefined): string | undefined {
  const trimmed = (trustNumber ?? '').trim();
  if (!trimmed) return undefined;

  return `/dashboard/portfolio/facility/${firstTrustNumber(trimmed).replaceAll('/', '-')}`;
}

/**
 * El primer fideicomiso de un número que puede venir agrupado.
 *
 * `"F/1477 / F/1477C"` → `"F/1477"`. Un número simple vuelve igual.
 */
export function firstTrustNumber(trustNumber: string): string {
  const [first] = trustNumber.split(/\s+\/\s+/);
  return first.trim();
}
